module.exports = __webpack_public_path__ + "static/media/signup-image-2.fe56db10.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/signup-image-2.jpg
// module id = 956
// module chunks = 0